import {
  LoadingStatus,
  SortDirection,
} from '../../../../utils/constants';
import {
  getCurrentFilterPresetList,
  loadColumnSettingConfiguration,
} from '../../../../services/ObjectConfiguration/ObjectConfiguration.service';
import { getUserRestriction, getUserCurrentPageName } from '../../../../services/AuthService/AuthService';
import { getUserTimezone } from '../../../../hooks/useAuth';

export const loadGridColumnSettingStoreAction = async ({
  dispatch,
  getState,
  searchPageSliceActions,
  getStateSliceForSearchPage,
  objectTypeGridColumns
}) => {
  const state = getState();
  const { loadingGridColumnStatus } = getStateSliceForSearchPage(state);
  const { username, assignedDivisions } = getUserRestriction(state.auth);
  // const { username, assignedDivisions } = state.auth.loginUser;

  if (
    loadingGridColumnStatus === LoadingStatus.Success
    || loadingGridColumnStatus === LoadingStatus.Loading
  ) {
    return;
  }

  dispatch(
    searchPageSliceActions.updateLoadingColumnSettingStatus(LoadingStatus.Loading)
  );
  try {
    const { visibleColumns, combineApplyingColumns } = await loadColumnSettingConfiguration({
      username, // Fixed for all the pages
      assignedDivisions,
      objectType: objectTypeGridColumns,
    });

    dispatch(searchPageSliceActions.updateVisibleGridColumns(visibleColumns));
    dispatch(searchPageSliceActions.updateMergedGridColumns(combineApplyingColumns));
    dispatch(
      searchPageSliceActions.updateLoadingColumnSettingStatus(LoadingStatus.Success)
    );
  } catch (error) {
    dispatch(
      searchPageSliceActions.updateLoadingColumnSettingStatus(LoadingStatus.Failed)
    );
  }
};

export const doSearchStoreAction = async ({
  dispatch, getState,
  searchPageSliceActions,
  getStateSliceForSearchPage,
  searchParamBuilder,
  searchWithPaginationApi,
  postResultsProcessHandler
}) => {
  dispatch(searchPageSliceActions.updateLoadingStatus(LoadingStatus.Loading));
  try {
    const state = getState();
    const { filter, tableInfo } = getStateSliceForSearchPage(state);
    const timezone = getUserTimezone(state);
    const searchParamData = {
      page: tableInfo.page + 1,
      pageSize: tableInfo.pageSize,
      sortBy: SortDirection.combineSortBy(
        tableInfo.sortColumn,
        tableInfo.sortDirection
      ),
      ...searchParamBuilder(filter, timezone),
    };

    const data = await searchWithPaginationApi(searchParamData);
    // console.log('Search results data:', data);
    const rowItems = data.Data;
    if (postResultsProcessHandler) {
      postResultsProcessHandler(rowItems);
    }
    dispatch(
      searchPageSliceActions.updateSearchResults({
        dataRowItems: rowItems,
        Count: data.Count,
      })
    );

    dispatch(searchPageSliceActions.updateLoadingStatus(LoadingStatus.Success));
  } catch (error) {
    console.log(error);
    dispatch(searchPageSliceActions.updateLoadingStatus(LoadingStatus.Failed));
  }
};

export const loadSavedFilterStoreAction = async ({
  dispatch, getState,
  searchPageSliceActions,
  getStateSliceForSearchPage,
  objectTypeForSaveUserFilter
}) => {
  const state = getState();
  const { username, userGlobalFilterPetroHub } = getUserRestriction(state.auth);
  const { isSavedFilterLoaded } = getStateSliceForSearchPage(state);
  const currentPageName = getUserCurrentPageName();
  // console.log('Current page name in loadSavedFilterStoreAction:', isSavedFilterLoaded, currentPageName, userGlobalFilterPetroHub);
  if (isSavedFilterLoaded) {
    return;
  }

  const currentSavedFilterList = await getCurrentFilterPresetList({
    objectType: objectTypeForSaveUserFilter,
    username,
  });
  dispatch(
    searchPageSliceActions.updateSavedFilterList(currentSavedFilterList)
  );
  console.log('userGlobalFilterPetroHub from loadSavedFilterStoreAction:', userGlobalFilterPetroHub);
  console.log('Applying global filter for PetroHub user on page load:', currentPageName);
  if ((currentPageName === 'Orders' || currentPageName === 'OrderRequest' || currentPageName === 'Cylinders' || currentPageName === 'samples') && userGlobalFilterPetroHub && userGlobalFilterPetroHub.length > 0 && userGlobalFilterPetroHub[0].Fields && userGlobalFilterPetroHub[0].Fields.length > 0 && userGlobalFilterPetroHub[0].Fields.some((f) => f.Value && f.Value.length > 0)) {
    const { Fields } = userGlobalFilterPetroHub[0];

    if (currentPageName === 'Orders' || currentPageName === 'OrderRequest' || currentPageName === 'Cylinders' || currentPageName === 'samples') {
      dispatch(searchPageSliceActions.applySavedFilter(Fields));
    }
  } else if (
    Array.isArray(currentSavedFilterList)
    && currentSavedFilterList.length > 0
  ) {
    const defaultFilterPreset = currentSavedFilterList.filter((x) => x.Default)[0];
    if (defaultFilterPreset) {
      const { Fields } = defaultFilterPreset;
      dispatch(searchPageSliceActions.applySavedFilter(Fields));
    }
  }
};
